import React from 'react'
import { Heading, Text, Button, Alert } from 'base-ui'
import Highlighter from './Highlight'
import { Button as ButtonExample } from '../examples/Button'
import { IconMail, IconArrowLeft, IconArrowRight } from '@paro.io/base-icons'
import { PageWrapper } from './PageWrapper'

const Buttons = () => {
  return (
    <PageWrapper title="Buttons">
      <Text size="lg">
        Buttons are used for actions, such as “Add”, “Close”, “Cancel”, “Save”, "View Settings".
        <ul className='list-disc ml-8 my-4'>
          <li><b>Primary buttons</b>, are used for important actions, such as "Create", "Add".</li>
          <li><b>Default buttons</b>, are used for less important, such as “View Settings”.</li>
          <li><b>Semantic buttons</b>, are used to encourage or discourage user behavior to: caution, inform or reasure of the result of an action such as "Delete".</li>
          <li><b>Icon buttons</b>, are used to call attention to an action or to diferentiate similar or oposite actions such as: "Send Email", "Play" and "Pause", "On" or "Off", "Delete" and "Remove". For labeled buttons use icons size small (sm), for icon-only buttons use size medium (md).</li>
        </ul>
      </Text>
      <div className="py-1 mb-8" >
        <Alert icon="info" color="info" variant="subtle" label="Icon buttons require base-icons npm package to be installed and prop values (icon, iconLeft, iconRight) as react elements NOT strings." />
      </div>

      <div className='flex space-x-2 mb-4'>
        <div className='flex-1 border border-gray-200 rounded p-8'>
          <Heading size="h5" className='mb-8'>On Light</Heading>
          <div className='space-x-2 mb-8'>
            <Button
              label='Reset'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="default"
            />
            <Button
              label='Save'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="primary"
            />
          </div>
          <div className='space-x-2 mb-8'>
            <Button
              label='Accept'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="success"
            />
            <Button
              label='Deny'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="danger"
            />
          </div>
          <div className='space-x-2 mb-8'>
            <Button
              label='Keep'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="default"
            />
            <Button
              label='Delete'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="danger"
            />
          </div>
          <div className='space-x-2 mb-8'>
            <Button
              label='Exit'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="default"
            />
            <Button
              label='Continue'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="warning"
            />
          </div>
          <div className='space-x-2 mb-8'>
            <Button
              label='Help'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="info"
            />
          </div>
        </div>

        <div className='flex-1 bg-blue p-8 rounded'>
          <Heading size="h5" className='mb-8 text-white'>On Dark</Heading>
          <div className='space-x-2 mb-8'>
            <Button
              label='Reset'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="default-on-dark"
            />
            <Button
              label='Save'
              onClick={() => console.log('clicked button!')}
              type='button'
              color="primary-on-dark"
            />
          </div>
        </div>
      </div>


      <Heading size="h4">Status</Heading>
      <div className='flex space-x-4 mb-4'>
        <Button
          label='Default'
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
        />
        <Button
          label='Disabled'
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
          disabled={true}
        />
        <Button
          label='Loading'
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
          isLoading={true}
        />
      </div>

      <Heading size="h4">Variants</Heading>
      <div className='flex space-x-2 mb-4'>
        <Button
          label='Text'
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
        />
        <Button
          onClick={() => console.log('clicked button!')}
          type='button'
          label="Left Icon"
          color="primary"
          iconLeft={<IconArrowLeft size="sm" />}
        />
        <Button
          onClick={() => console.log('clicked button!')}
          type='button'
          label="Right Icon"
          color="primary"
          iconRight={<IconArrowRight size="sm" />}
        />
        <Button
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
          icon={<IconMail />}
        />
      </div>

      <Heading size="h4">Sizes</Heading>
      <div className='flex space-x-2 mb-4'>
        <Button
          label='Small'
          onClick={() => console.log('clicked button!')}
          type='button'
          color="primary"
          size={"sm"}
          iconRight={<IconArrowRight size="sm" />}
        />
        <Button
          onClick={() => console.log('clicked button!')}
          type='button'
          label='Medium'
          color="primary"
          iconRight={<IconArrowRight size="sm" />}
        />
        <Button
          onClick={() => console.log('clicked button!')}
          size={"lg"}
          type='button'
          label="Large"
          color="primary"
          iconRight={<IconArrowRight size="md" />}
        />
      </div>

      <Heading size="h3">Usage</Heading>
      <Highlighter code={ButtonExample} language='jsx' />
    </PageWrapper>
  )
}

export default Buttons
